/**
 * @generated SignedSource<<95b0dcedbf51a1ddf1f22f25eac3c823>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PortfolioAssetGroupsCountViewQuery$variables = Record<PropertyKey, never>;
export type PortfolioAssetGroupsCountViewQuery$data = {
  readonly portfolio: {
    readonly assetGroups: {
      readonly edges: ReadonlyArray<{
        readonly name: string;
        readonly totalAssets: number | null | undefined;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PortfolioAssetGroupsCountViewQuery = {
  response: PortfolioAssetGroupsCountViewQuery$data;
  variables: PortfolioAssetGroupsCountViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Portfolio",
    "kind": "LinkedField",
    "name": "portfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PortfolioAssetGroupsConnection",
        "kind": "LinkedField",
        "name": "assetGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PortfolioAssetGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalAssets",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioAssetGroupsCountViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PortfolioAssetGroupsCountViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ca8b863e875c9c0c255851ec0eb4315b",
    "id": null,
    "metadata": {},
    "name": "PortfolioAssetGroupsCountViewQuery",
    "operationKind": "query",
    "text": "query PortfolioAssetGroupsCountViewQuery {\n  portfolio {\n    assetGroups {\n      edges {\n        name\n        totalAssets\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "47de6f1bfd8d23816c55fd6d76594c75";

export default node;
